import {
  // Modules
  faUserGear as UserManagementsModuleIcon,
  faClockRotateLeft as LogsModuleIcon,
  // File manager icons
  faFolderPlus as NewFolderIcon,
  faArrowUpFromBracket as UploadIcon,
  faBarsSort as SortIcon,
  faImage as ImageIcon,
  faFileImage as FileImageIcon,
  faVideo as VideoIcon,
  faMusic as AudioIcon,
  faFile as DocumentIcon,
  faGrid2 as View1Icon,
  faList as View2Icon,
  // icons
  faFilter as FilterIcon,
  faMagnifyingGlass as SearchIcon,
  faCircleInfo as InfoIcon,
  faCircleExclamation as AlertCircleIcon,
  faPlus as PlusIcon,
  faCircle as CircleIcon,
  faXmark as XIcon,
  faCheck as CheckIcon,
  faCircleCheck as CircleCheckIcon,
  faPen as EditIcon,
  faArrowRotateLeft as UndoIcon,
  faArrowRotateRight as RedoIcon,
  faCopy as CopyIcon,
  faGripDotsVertical as DragAndDropIcon,
  faClone as CloneIcon,
  faPlay as ResumeIcon,
  faBoxArchive as ArchiveIcon,
  faCloudArrowUp as ImportIcon,
  faCloudArrowDown as ExportIcon,
  faClone as DuplicateIcon,
  faArrowsRotate as RefreshIcon,
  faColumns3 as ColumnsIcon,
  faUser as UserIcon,
  faUserGroup as UserGroupIcon,
  faKey as PasswordIcon,
  faTag as TagIcon,
  faGear as PreferenceIcon,
  faLock as LockIcon,
  faUserPlus as UserPlusIcon,
  faUserLock as UserLockIcon,
  faUserUnlock as UserUnlockIcon,
  faUserGear as UserPreferenceIcon,
  faUserCheck as UserActivateIcon,
  faUserXmark as UserDeactivateIcon,
  faPlay as PlayIcon,
  faPause as PauseIcon,
  faFolder as FolderIcon,
  faFileText as FileTextIcon,
  faTableLayout as TableLayoutIcon,
  faArrowLeft as ArrowLeftIcon,
  faArrowRight as ArrowRightIcon,
  faArrowDownToBracket as DownloadIcon,
  faChevronDown as ChevronDownIcon,
  faChevronRight as ChevronRightIcon,
  faChevronLeft as ChevronLeftIcon,
  faEye as EyeIcon,
  faPaperclip as AttachmentIcon,
  faArrowsUpDownLeftRight as MoveIcon,
  faEllipsisVertical as EllipsisVerticalIcon,
  faArrowRotateLeft as RestoreIcon,
  faCloudArrowUp as CloudUploadIcon,
  faCloudArrowDown as CloudDownloadIcon,
  faCloud as CloudIcon,
  faArrowsRepeat as RepeatIcon,
  faEnvelope as EnvelopeIcon,
  faPhone as PhoneIcon,
  faHashtag as HashIcon,
  faText as TextIcon,
  faSquareBolt as UpgradePlanIcon,
  faCircleXmark as CircleXIcon,
  faFloppyDisk as FloppyDiskIcon,
  faCalendarCheck as CalendarCheckIcon,
  faCalendarLinesPen as CalendarLinesPenIcon,
  faClock as ClockIcon,
  faShare as ShareIcon,
  faLink as LinkIcon,
  faArrowUpRightFromSquare as ExternalLinkIcon,
  faPaperPlaneTop as PaperPlaneTopIcon,
  faDownToLine as DownToLineIcon,
  faUpload as DiskUploadIcon,
  faUpFromLine as UpFromLineIcon,
  faFileExport as FileExportIcon,
  faBookmark as BookmarkIcon,
  faBookmarkSlash as BookmarkSlashIcon
} from "@fortawesome/pro-regular-svg-icons"

import {
  // icons
  faTrash as DeleteIcon,
  faFilePdf as PdfIcon,
  faTriangleExclamation as AlertIcon,
  faCloudArrowUp as CloudUploadSoildIcon,
  faCloudArrowDown as CloudDownloadSoildIcon,
  faAngleDown as AngleDownSoildIcon,
  faAngleRight as AngleRightSoildIcon,
  faPalette as PaletteSoildIcon,
  faFillDrip as FillDripSoildIcon,
  faQuestionCircle as QuestionCircleSoildIcon,
  faPen as PenSoildIcon,
  faCircleExclamation as CircleExclamationSolidIcon,
  faCircleCheck as CircleCheckSoildIcon
} from "@fortawesome/pro-solid-svg-icons"

export {
  // modules
  UserManagementsModuleIcon,
  LogsModuleIcon,
  // file manager icons
  NewFolderIcon,
  UploadIcon,
  DiskUploadIcon,
  UpFromLineIcon,
  SortIcon,
  ImageIcon,
  FileImageIcon,
  VideoIcon,
  AudioIcon,
  DocumentIcon,
  View1Icon,
  View2Icon,
  // icons
  FilterIcon,
  SearchIcon,
  AlertIcon,
  InfoIcon,
  AlertCircleIcon,
  PlusIcon,
  PdfIcon,
  CloudDownloadIcon,
  CloudDownloadSoildIcon,
  CloudUploadIcon,
  CloudUploadSoildIcon,
  CloudIcon,
  CircleIcon,
  XIcon,
  CheckIcon,
  CircleCheckIcon,
  CircleCheckSoildIcon,
  DeleteIcon,
  EditIcon,
  UndoIcon,
  RedoIcon,
  CopyIcon,
  MoveIcon,
  DragAndDropIcon,
  CloneIcon,
  ResumeIcon,
  ArchiveIcon,
  ImportIcon,
  ExportIcon,
  DuplicateIcon,
  RefreshIcon,
  ColumnsIcon,
  UserIcon,
  UserGroupIcon,
  PasswordIcon,
  TagIcon,
  PreferenceIcon,
  LockIcon,
  UserPlusIcon,
  UserLockIcon,
  UserUnlockIcon,
  UserPreferenceIcon,
  UserActivateIcon,
  UserDeactivateIcon,
  PlayIcon,
  PauseIcon,
  FolderIcon,
  FileTextIcon,
  TableLayoutIcon,
  ArrowLeftIcon,
  ArrowRightIcon,
  DownloadIcon,
  ChevronDownIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  EyeIcon,
  AttachmentIcon,
  EllipsisVerticalIcon,
  RestoreIcon,
  RepeatIcon,
  EnvelopeIcon,
  PhoneIcon,
  HashIcon,
  TextIcon,
  CalendarCheckIcon,
  CalendarLinesPenIcon,
  ClockIcon,
  ShareIcon,
  LinkIcon,
  ExternalLinkIcon,
  AngleDownSoildIcon,
  AngleRightSoildIcon,
  PaletteSoildIcon,
  FillDripSoildIcon,
  QuestionCircleSoildIcon,
  PenSoildIcon,
  CircleExclamationSolidIcon,
  UpgradePlanIcon,
  CircleXIcon,
  FloppyDiskIcon,
  PaperPlaneTopIcon,
  DownToLineIcon,
  FileExportIcon,
  BookmarkIcon,
  BookmarkSlashIcon
}
